import {
  call,
  put,
  delay,
  takeLeading,
  takeLatest,
  select,
} from 'redux-saga/effects'
import {
  types,
  ICreateMediaTypeGroupAction,
  IGetMediaTypeGroupByIdAction,
  IUpdateMediaTypeGroupAction,
  IDeleteMediaTypeGroupAction,
} from '../types/mediaTypeGroup'
import { Modals } from '../types/modal'
import * as actions from '../actions/mediaTypeGroup'
import * as mediaTypeGroupsActions from '../actions/mediaTypesGroups'
import { push } from '../actions/router'
import { modalOpen } from '../actions/modal'
import { selectMediaTypeGroup } from '../selectors/mediaTypesGroups'
import * as services from '../services/mediaTypeGroups'
import { trace } from '../services/common'
import { messages } from '../config/messages'

export function* createMediaTypeGroupSaga(action: ICreateMediaTypeGroupAction) {
  try {
    const mediaTypeGroupData = yield call(
      services.createMediaTypeGroup,
      action.mediaTypeGroupData
    )
    yield delay(0)
    yield put(
      actions.createMediaTypeGroupSuccess(
        mediaTypeGroupData,
        messages.createMediaTypeGroupCreateSuccess(mediaTypeGroupData.title)
      )
    )
    yield put(mediaTypeGroupsActions.getMediaTypeGroups())
    yield delay(500) // show success message before redirect
    yield put(push('/settings/media-type-groups?tab=all-groups'))
  } catch (err) {
    trace(err)
    yield put(actions.createMediaTypeGroupFailure(err.message))
  }
}

export function* getMediaTypeGroupSaga(action: IGetMediaTypeGroupByIdAction) {
  try {
    const mediaTypeGroupData = yield call(services.getMediaTypeById, action.id)
    yield put(actions.getMediaTypeGroupByIdSuccess(mediaTypeGroupData))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-type-groups?tab=all-groups'))
    }
    yield put(actions.getMediaTypeGroupByIdFailure(err.message))
  }
}

export function* updateMediaTypeGroupSaga(action: IUpdateMediaTypeGroupAction) {
  try {
    const mediaTypeGroupData = yield call(
      services.updateMediaTypeGroup,
      action.mediaTypeGroupData
    )
    yield put(actions.updateMediaTypeGroup(mediaTypeGroupData))
    yield put(
      actions.updateMediaTypeGroupSuccess(
        mediaTypeGroupData,
        messages.createMediaTypeGroupUpdateSuccess(mediaTypeGroupData.title)
      )
    )
    yield put(mediaTypeGroupsActions.getMediaTypeGroups())
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-type-groups?tab=all-groups'))
    }
    yield put(actions.updateMediaTypeGroupFailure(err.message))
  }
}

export function* deleteMediaTypeGroupSaga(action: IDeleteMediaTypeGroupAction) {
  try {
    const mediaTypeGroupData = yield select(selectMediaTypeGroup)
    yield call(services.deleteMediaTypeGroup, action.id)
    yield put(
      actions.deleteMediaTypeGroupSuccess(
        messages.createMediaTypeGroupDeleteSuccess(mediaTypeGroupData.title)
      )
    )
    yield put(push('/settings/media-type-groups?tab=all-groups'))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-type-groups?tab=all-groups'))
    } else {
      yield put(modalOpen(Modals.deleteStatusModal))
    }
    yield put(actions.deleteMediaTypeGroupFailure(err.message))
  }
}

export function* mediaTypeGroupWatcher() {
  yield takeLeading(
    types.CREATE_MEDIA_TYPE_GROUP__STARTED,
    createMediaTypeGroupSaga
  )
  yield takeLatest(
    types.GET_MEDIA_TYPE_GROUP_BY_ID__STARTED,
    getMediaTypeGroupSaga
  )
  yield takeLeading(
    types.UPDATE_MEDIA_TYPE_GROUP__STARTED,
    updateMediaTypeGroupSaga
  )
  yield takeLatest(
    types.DELETE_MEDIA_TYPE_GROUP__STARTED,
    deleteMediaTypeGroupSaga
  )
}
